export default __webpack_public_path__ + "static/Gellix-Medium-0fd133d1a87c058df43fb14e63bbb439.woff";